import BaseService from "@/services/BaseService";
export default class LaboratoryService extends BaseService{
  constructor() {
    super('odoo/laboratory');
  }

  async FindAllActive() {
    return await this.http.get(this._serviceName+'/', { params: {'active': true} });
  }
}
